import { api, apiUrl } from "../../shared/services/service";
import { AdminBqTqFormGridRow, AdminBqTqFormResponseRow } from "../models/admin-bq-tq-forms.models";
import axios from "axios";

const toText = (value: unknown) => String(value ?? "").trim();

export const toAdminBqTqFormGridRow = (row: AdminBqTqFormResponseRow): AdminBqTqFormGridRow => {
  const formType = row.FORM_TYPE === "BALTIC_QUESTIONNAIRE" ? "Baltic Questionnaire" : "Tech Form";
  const imoNumber = toText(row.IMO_NUMBER);
  const vesselName = toText(row.VESSEL_NAME);

  return {
    gridRowId: `${row.FORM_TYPE}-${imoNumber}-${vesselName}-${toText(row.REQUESTED_ON)}`,
    formType,
    vesselName,
    imoNumber,
    vesselCode: toText(row.VESSEL_CODE),
    vesselMasterEmail: toText(row.VESSEL_MASTER_EMAIL),
    status: toText(row.SUBMIT_STATUS),
    requestedOn: toText(row.REQUESTED_ON),
    submittedOn: toText(row.SUBMITTED_ON),
    submittedVia: toText(row.SUBMITTED_VIA) || "WEB",
    submittedByEmail: row.SUBMITTED_BY_EMAIL ? "Yes" : "No",
    tcCode: toText(row.TCCODE),
  };
};

export const getAdminBqTqForms = async (): Promise<{ rows: AdminBqTqFormResponseRow[] }> => {
  const response = await api.get(`${apiUrl}/admin/bq-tq/forms`);
  return response.data;
};

export const getAdminBqTqFormsErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  return error instanceof Error ? error.message : "Could not load BQ/TQ forms.";
};
